if (objects.is_offres) {

  let price_personnalisee = document.querySelector(".carte-2 .box-middle .price")
  const button_minus_personnalisee = document.querySelector(".carte-2 .selecteur .box.moins")
  const button_plus_personnalisee = document.querySelector(".carte-2 .selecteur .box.plus")
  const players_personnalisee = document.querySelector(".carte-2 .selecteur .box.nombre")
  const players_personnalisee_max = players_personnalisee.getAttribute('data-max');
  const players_personnalisee_min = players_personnalisee.getAttribute('data-min');
  let nombre_personnalisee = parseInt(players_personnalisee.innerHTML)

  let price_partenaires = document.querySelector(".carte-3 .box-middle .price")
  const button_minus_partenaires = document.querySelector(".carte-3 .selecteur .box.moins")
  const button_plus_partenaires = document.querySelector(".carte-3 .selecteur .box.plus")
  const players_partenaires = document.querySelector(".carte-3 .selecteur .box.nombre")
  const players_partenaires_max = players_partenaires.getAttribute('data-max');
  const players_partenaires_min = players_partenaires.getAttribute('data-min');
  let nombre_partenaires = parseInt(players_partenaires.innerHTML)

  let price_multiverse = document.querySelector(".carte-1 .box-middle .price")
  const button_minus_multiverse = document.querySelector(".carte-1 .selecteur .box.moins")
  const button_plus_multiverse = document.querySelector(".carte-1 .selecteur .box.plus")
  const players_multiverse = document.querySelector(".carte-1 .selecteur .box.nombre")
  const players_multiverse_max = players_multiverse.getAttribute('data-max');
  const players_multiverse_min = players_multiverse.getAttribute('data-min');
  let nombre_multiverse = parseInt(players_multiverse.innerHTML)
    
    function cursor_personnalisee() {
      if (nombre_personnalisee <= players_personnalisee_min ) {
        button_minus_personnalisee.style.cursor = "default"
      } else if (nombre_personnalisee >= players_personnalisee_max){
        button_plus_personnalisee.style.cursor = "default"
      } else {
        button_minus_personnalisee.style.cursor = "pointer"
        button_plus_personnalisee.style.cursor = "pointer"
      }
    }
    function cursor_partenaires() {
      if (nombre_partenaires <= players_partenaires_min ) {
        button_minus_partenaires.style.cursor = "default"
      } else if (nombre_partenaires >= players_partenaires_max){
        button_plus_partenaires.style.cursor = "default"
      } else {
        button_minus_partenaires.style.cursor = "pointer"
        button_plus_partenaires.style.cursor = "pointer"
      }
    }
    function cursor_multiverse() {
      if (nombre_multiverse <= players_multiverse_min ) {
        button_minus_multiverse.style.cursor = "default"
      } else if (nombre_multiverse >= players_multiverse_max){
        button_plus_multiverse.style.cursor = "default"
      } else {
        button_minus_multiverse.style.cursor = "pointer"
        button_plus_multiverse.style.cursor = "pointer"
      }
    }
  
    function calcul_personnalisee() {
      players_personnalisee.innerHTML = nombre_personnalisee
  
      switch (nombre_personnalisee) {
        case 3:
          price_personnalisee.innerHTML = 35
          break;
        case 4:
          price_personnalisee.innerHTML = 30
          break;
        case 5:
          price_personnalisee.innerHTML = 27
          break;
        default:
          price_personnalisee.innerHTML = 24
          break;
      }
    }
    function calcul_partenaires() {
      players_partenaires.innerHTML = nombre_partenaires
  
      switch (nombre_partenaires) {
        case 3:
          price_partenaires.innerHTML = 35
          break;
        case 4:
          price_partenaires.innerHTML = 30
          break;
        case 5:
          price_partenaires.innerHTML = 27
          break;
        default:
          price_partenaires.innerHTML = 24
          break;
      }
    }
    function calcul_multiverse() {
      players_multiverse.innerHTML = nombre_multiverse
  
      switch (nombre_multiverse) {
        default:
          price_multiverse.innerHTML = 50
          break;
      }
    }
  
    button_minus_personnalisee.addEventListener('click', () => {
      if (nombre_personnalisee > players_personnalisee_min ) {
        nombre_personnalisee -= 1
      }
      cursor_personnalisee()
      calcul_personnalisee()
    })
    button_plus_personnalisee.addEventListener('click', () => {
      if (nombre_personnalisee < players_personnalisee_max ) {
        nombre_personnalisee -= -1
      }
      cursor_personnalisee()
      calcul_personnalisee()
    })
  
    button_minus_partenaires.addEventListener('click', () => {
      if (nombre_partenaires > players_partenaires_min ) {
        nombre_partenaires -= 1
      }
      cursor_partenaires()
      calcul_partenaires()
    })
    button_plus_partenaires.addEventListener('click', () => {
      if (nombre_partenaires < players_partenaires_max ) {
        nombre_partenaires -= -1
      }
      cursor_partenaires()
      calcul_partenaires()
    })
  
    button_minus_multiverse.addEventListener('click', () => {
      if (nombre_multiverse > players_multiverse_min ) {
        nombre_multiverse -= 1
      }
      cursor_multiverse()
      calcul_multiverse()
    })
    button_plus_multiverse.addEventListener('click', () => {
      if (nombre_multiverse < players_multiverse_max ) {
        nombre_multiverse -= -1
      }
      cursor_multiverse()
      calcul_multiverse()
    })
  
    cursor_personnalisee()
    calcul_personnalisee()
  
    cursor_partenaires()
    calcul_partenaires()
  
    cursor_multiverse()
    calcul_multiverse()
}
